import React, { useCallback, useState, useEffect } from "react";
import { AutoComplete, Input, Select } from "antd";
import { Redirect } from "react-router-dom";
import { search } from "./search-service";

import "./styles.css";

const CLEAN_REGEX = /[\s\-._/]+/g;

function normalizeSearchText(text) {
  if (!text) {
    return "";
  }
  return text.toString().trim().toLowerCase().replace(CLEAN_REGEX, "");
}

export function MultiSearch() {
  const [data, setData] = useState([]);
  const [redirectTo, setRedirectTo] = useState(null);
  const [searchBy, setSearchBy] = useState("pasta");
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = useCallback(
    (text) => {
      const cleaned = normalizeSearchText(text);

      // Exige pelo menos 2 caracteres significativos após limpar espaços/traços/pontos/etc
      if (!cleaned || cleaned.length < 2) {
        setData([]);
        return;
      }

      search(text, searchBy)
        .then((response) => {
          if (!response || response.length === 0) {
            setData(["Nada encontrado"]);
            return;
          }

          // espera-se que `response` seja uma lista de objetos com campo `pasta`
          setData(
            response.map(function (pasta) {
              return pasta.pasta;
            })
          );
        })
        .catch(function (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    },
    [searchBy]
  );

  useEffect(
    function () {
      setData([]);
      setSearchValue("");
    },
    [searchBy]
  );

  const handleSelect = useCallback((value) => {
    if (value === "Nada encontrado") {
      return;
    }
    setRedirectTo("/pasta/" + value);
  }, []);

  return (
    <React.Fragment>
      <div className="auto-complete-wrapper">
        <AutoComplete
          value={searchValue}
          onChange={function (value) {
            setSearchValue(value);
          }}
          placeholder={
            "Pesquisar por " + (searchBy === "pasta" ? "pasta" : "núm. cliente")
          }
          autoFocus
          onSearch={handleSearch}
          onSelect={handleSelect}
          style={{
            width: "100%",
            minWidth: "200px",
          }}
          dataSource={data}
        />
        <Select
          className="search-select"
          defaultValue="pasta"
          style={{ minWidth: "130px", marginLeft: "-1px" }}
          onChange={function (value) {
            setSearchBy(value);
          }}
        >
          <Select.Option value="pasta">Pasta</Select.Option>
          <Select.Option value="numero_cliente">Número cliente</Select.Option>
        </Select>
      </div>

      {redirectTo ? <Redirect to={redirectTo} push /> : null}
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/Search/v2/multi-search.jsx